import React from 'react'
import { t } from 'ttag'

const WIPPanel = () => {
  return (
    <div>
      <div>
        <p>
          {t`The Work Importance Profiler allows you to identify the qualities of a job that are most important 
                to you and then identify occupations that most closely align with those values.`}
        </p>
      </div>
      <div className="embed-responsive embed-responsive-16by9">
        <video
          className="embed-responsive-item"
          controls="true"
          poster={
            '/images/headed2/marketing/features/H2-Video-ToolDemo-Bookends-0720-v1_WIP.jpg'
          }>
          <source
            src="https://s3.amazonaws.com/h2-marketing/WorkImportanceProfiler.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  )
}

export default WIPPanel
